var map = {
	"./arrow-up.svg": 2244,
	"./checkbox-checked.svg": 9348,
	"./checkbox.svg": 2680,
	"./customer-service.svg": 1152,
	"./customer-service2.svg": 6308,
	"./icon-add.svg": 5556,
	"./icon-arrow-down.svg": 941,
	"./icon-arrow-up.svg": 152,
	"./icon-close.svg": 7828,
	"./icon-geo.svg": 5712,
	"./icon-minus.svg": 9460,
	"./icon-search.svg": 3772,
	"./icon-service.svg": 6448,
	"./icon-shopping-cart.svg": 3812,
	"./icon-success.svg": 9068,
	"./icon-top.svg": 1972,
	"./telephone.svg": 7900
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6780;